<template>
  <div class="content-wrapper">
    <h2 class="page-titles">E-commerce</h2>

    <!-- <Skeleton v-if="loadShopDetails" width="100%" height="4rem" /> -->

    <div class="store-header">
      <div class="flex gap-3 items-center">
        <div class="w-9">
          <img
            v-if="shopDetails.logoImage.url"
            :src="shopDetails.logoImage.url"
            class="store-image"
          />
        </div>
        <div class="w-auto" v-if="shopDetails.title">
          <h4 class="editorial store-title capitalize">
            {{ shopDetails.title }}
          </h4>
        </div>
      </div>
      <div class="divider"></div>
      <button class="store-location">
        {{
          `${shopDetails.stripeAccountBlob.supportAddress.state}, ${shopDetails.stripeAccountBlob.supportAddress.country}`
        }}
      </button>
    </div>

    <div class="mt-5" v-if="showPublishBanner">
      <Skeleton v-if="loadShopDetails" width="100%" height="7rem" />

      <EcommercePublishSiteBanner
        @closeBanner="showPublishBanner = false"
        v-else
      />
    </div>
    <Skeleton
      v-if="loadShopDetails"
      width="30%"
      height="3rem"
      style="margin-top: 1rem; margin-left: auto"
    />

    <div class="filter flex ml-auto mt-8" v-if="!loadShopDetails">
      <div class="date-filter flex items-center justify-end gap-2 ml-auto">
        <div class="date-filter-title flex items-center gap-2">
          <img src="../../assets/filter-icon.svg" />
          <span class="font-normal text-sm">Date</span>
        </div>
        <el-select v-model="dateFilter" placeholder="Select">
          <el-option
            v-for="(filter, key) in dateFilters"
            :key="key"
            :label="filter.label"
            :value="filter.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="stats mt-10">
      <div class="flex mb-4 gap-4">
        <!-- Orders Data Here -->
        <div class="w-1/2 border-2 text-left pt-4 pb-2 px-5 stats-container">
          <div class="flex gap-2 items-center">
            <img src="../../assets/order-icon.svg" class="w-4" />
            <h4>Orders</h4>
          </div>
          <div class="mt-6">
            <p class="stats-desc">Total orders {{ filterLabel }}</p>
            <Skeleton
              v-if="loadShopDetails"
              width="10%"
              height="2rem"
              style="margin-top: 1rem"
            />

            <span v-else class="stat-value block">
              {{ shopStats.total_orders }}
            </span>
          </div>
        </div>

        <!-- Sales Data Here -->
        <div class="w-1/2 border-2 text-left pt-4 pb-2 px-5 stats-container">
          <div class="flex gap-2 items-center mb-5">
            <img src="../../assets/line-chart.svg" class="w-4" />
            <h4>Sales</h4>
          </div>
          <div class="mt-6">
            <p class="stats-desc">Total sales {{ filterLabel }}</p>
            <Skeleton
              v-if="loadShopDetails"
              width="10%"
              height="2rem"
              style="margin-top: 1rem"
            />
            <span class="stat-value block" v-else>
              {{ shopStats.total_revenue }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row gap-4" v-if="false">
        <div
          class="w-full md:w-1/2 border-2 text-left pt-4 pb-2 px-5 stats-container"
        >
          <div class="flex gap-3 items-center mb-10">
            <img src="../../assets/sessions-icon.svg" />
            <h4 class="">Sessions</h4>
          </div>
          <div class="flex gap-6 flex-wrap md:flex-nowrap justify-between">
            <div class="md:w-2/5 w-1/2">
              <p class="stats-desc">Total sessions today</p>
              <span class="stat-value">0</span>
            </div>

            <div class="md:w-2/5 w-1/2">
              <p class="stats-desc">Total visitors today</p>
              <span class="stat-value">0</span>
            </div>
          </div>
        </div>
        <div
          v-if="false"
          class="w-full md:w-1/2 border-2 text-left md:py-4 relative blog-card-container"
        >
          <div class="md:absolute -top-1 left-0 w-full h-full blog-card">
            <BlogCard />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Util from '../../mixins/Util'
import Skeleton from '../Universal/Skeleton'
import { layouts } from '@/helpers'
import EcommercePublishSiteBanner from './EcommercePublishSiteBanner.vue'
import BlogCard from '../Universal/BlogCard.vue'
export default {
  name: 'EcommerceDashboard',
  mixins: [Util],
  components: {
    Skeleton,
    EcommercePublishSiteBanner,
    BlogCard
  },
  data: () => ({
    dateFilters: [
      {
        label: 'Today',
        value: 'today'
      },
      {
        label: 'Yesterday',
        value: 'yesterday'
      },
      {
        label: 'Last 7 days',
        value: 'last_7_days'
      },
      {
        label: 'Last 30 days',
        value: 'last_30_days'
      },
      {
        label: 'All time',
        value: ''
      }
    ],
    dateFilter: 'today',
    showPublishBanner: false
  }),
  computed: {
    filterLabel() {
      return this.dateFilters.find(filter => filter.value === this.dateFilter)
        .label
    },
    ...mapState({
      shopStats: state => state.ecommerce.shopStats,
      loadShopStats: state => state.ecommerce.loadShopStats,
      shopDetails: state => state.ecommerce.shopDetails,
      loadShopDetails: state => state.ecommerce.loadShopDetails
    })
  },
  watch: {
    dateFilter() {
      this.$store.dispatch('ecommerce/getDashboardStats', {
        time_period: this.dateFilter
      })
    }
  },
  created() {
    this.$store.dispatch('ecommerce/getDashboardStats')
    this.$store.dispatch('ecommerce/getStoreDetails')
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    console.log(this.shopDetails)
  }
}
</script>

<style scoped lang="scss">
.live-users {
  position: relative;
  background: #fef3ef;
  border-radius: 6px;
  color: #da5737;
  width: 87px;
  &::after {
    content: ' ';
    width: 6px;
    height: 6px;
    background: #ce0809;
    position: absolute;
    left: 14px;
    top: 13px;
    border-radius: 50%;
  }
}

.date-filter {
  width: 100%;
}

.date-filter-title {
  span {
    font-size: 0.835rem;
    font-weight: 600;
  }
}

.stat-value {
  font-family: 'Inter', sans-serif;
  font-size: 2rem;
  color: #24292c;
}

.border-2 {
  border: 1px solid #232220;
}

.store-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #232220;
  padding: 0.8rem 1.8rem;
  border-radius: 12px;
}

.store-image {
  border-radius: 6px;
}

.stats-container {
  h4 {
    font-family: 'Editorial';
    font-weight: normal;
    font-size: 1.5rem;
  }
  .stats-desc {
    text-align: left;
    font-size: 0.853rem;
    color: #232220;
    p {
      font-size: 1.75rem;
      margin-top: 0.2rem;
    }
  }
}

.blog-card-container {
  background-color: #dfdad2;
  border-radius: 6px;
  .blog-card {
    scale: 1.01;
  }
}

.store-title {
  font-weight: 300;
  color: #f5f2ee;
}
.store-location {
  font-weight: 300;
  color: #f5f2ee;
  font-size: 0.75rem;
  padding: 5px 18px;
  border-radius: 40px;
  border: 1px solid #f5f2ee;
}
.divider {
  width: 69%;
  height: 1px;
  background: #ffffff;
}
@media (max-width: 1410px) {
  .divider {
    width: 60%;
  }
}
@media (max-width: 851px) {
  .divider {
    width: 50%;
  }
}
@media (max-width: 604px) {
  .divider {
    width: 40%;
  }
}
@media (max-width: 513px) {
  .divider {
    width: 20%;
    display: none;
  }
}
</style>
